import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import arrowright from '../Assets/arrowright.png'
import { FaPhoneVolume , FaArrowRightLong } from "react-icons/fa6";
import { Link } from 'react-router-dom';
import styles from '../styles.js'
import {room1, room2, room3, room4} from '../Assets/rooms/index.js'

const StockSlides = (props) => {
    const {t, i18n} = useTranslation();
    const isRTL = i18n.language === 'ar';
    const rooms =[
        room1, room2, room3, room4
    ]
    const [isReversing, setIsReversing] = useState(false);

    // Add animation keyframes using style tag
    const animationKeyframes = `
        @keyframes slideLeft {
            0% { transform: translateX(0); }
            100% { transform: translateX(calc(-33.33% - 10rem)); }
        }
        @keyframes slideRight {
            0% { transform: translateX(calc(-33.33% - 10rem)) ; }
            100% { transform: translateX(0); }
        }
        .slider {
            animation-play-state: running;
        }
        .slider:hover {
            animation-play-state: paused;
        }
    `;

    useEffect(() => {
        const handleAnimationEnd = () => {
            setIsReversing(prev => !prev);
        };

        const slider = document.querySelector('.slider');
        if (slider) {
            slider.addEventListener('animationend', handleAnimationEnd);
        }

        return () => {
            if (slider) {
                slider.removeEventListener('animationend', handleAnimationEnd);
            }
        };
    }, []);

    const animationClass = isReversing 
        ? "animate-[slideRight_0.2s_linear]" 
        : "animate-[slideLeft_10s_linear]";

  return (
    <>
        <style>{animationKeyframes}</style>
        <div name='stock' className={`${props.motherclassName} ${isRTL ? 'rtl' : 'ltr'}`}>
            <div className={`${props.className1}`}>
                <img loading="lazy" src={arrowright} alt='arrow' className={`h-6 animate-[slideRight_1s_linear] ${isRTL && 'rotate-180'}`}/> 
                <h1 className={`my-0 ${props.className2} text-primary02 font-bold`}>{t('homepage.stockRooms.title')}</h1>  
                <p className={`${props.className3} text-paragraph`}>{t('homepage.stockRooms.description')}</p>
                <div className={`flex items-center text-primary ${props.className4}`}>
                    <FaPhoneVolume className={`${isRTL ? 'rotate-[225deg]' : 'rotate-45'}`}   />
                    <a href="//api.whatsapp.com/send?phone=212661267760" target='_blank' rel='noreferrer'>              
                        <h3 className='font-bold'>{t('homepage.stockRooms.phone')}</h3>
                    </a>
                </div>
                <div className={`flex w-auto items-center justify-end`}>
                    <button className={`${styles.primaryBotton} rounded-full`}>
                        <Link to={'contact'} smooth duration={50} className='flex justify-center items-center gap-4 px-3 py-1'>
                            {t('contact.callus')}
                            <FaArrowRightLong size={20} className={`text-white ${isRTL && 'rotate-180'}`}/>
                        </Link>
                    </button>
                </div>
            </div> 
            <div className={`overflow-hidden flex justify-center items-center ${props.className5}`}>
                <div className={`slider flex gap-5 md:gap-10 ${animationClass} h-full`} style={{ width: 'fit-content' }}>
                    {rooms.map((room, index) => (
                        <div key={index} className='h-full aspect-square rounded-xl md:rounded-3xl'>
                            <img src={room} alt={`room-${index}`} className='w-full h-full object-cover rounded-xl md:rounded-3xl'/>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    </>
  )
}

export default StockSlides